/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Load_Failed1Inputs */

const vi_cmspost_load_failed1 = /** @type {(inputs: Cmspost_Load_Failed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tải được danh sách bài viết. Tải lại trang để thử lại.`)
};

/**

* @param {Cmspost_Load_Failed1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_load_failed1 = /** @type {((inputs?: Cmspost_Load_Failed1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Load_Failed1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_load_failed1(inputs)
});
export { cmspost_load_failed1 as "cmsPost_load_failed" }